import type { InitOptions } from 'i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { BaseLanguageType } from '../marketplace';

export interface LanguageItem<T = BaseLanguageType> {
  key: T;
  name: string;
}

export const LOCAL_STORAGE_KEY_LANG = 'language';
export const QUERY_KEY_LANG = LOCAL_STORAGE_KEY_LANG;

export const BaseLanguageList: LanguageItem[] = [
  {
    key: BaseLanguageType.EN,
    name: 'English',
  },
  {
    key: BaseLanguageType.ZH_TW,
    name: '繁體中文',
  },
  {
    key: BaseLanguageType.ZH_CN,
    name: '简体中文',
  },
];

const initI18n = async (options: InitOptions = {}) => {
  i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(HttpApi)
    .init({
      detection: {
        // Prevent localStorage key auto created
        // caches: [],
        lookupLocalStorage: LOCAL_STORAGE_KEY_LANG,
        lookupQuerystring: QUERY_KEY_LANG,
        order: ['querystring', 'localStorage', 'navigator'],
      },
      fallbackLng(code) {
        if (['zh-CHS', 'zh-Hans', 'zh-SG'].includes(code))
          return BaseLanguageType.ZH_CN;
        if (['zh-CHT', 'zh-Hant', 'zh-HK', 'zh-MO'].includes(code))
          return BaseLanguageType.ZH_TW;
        return BaseLanguageType.EN;
      },
      ns: ['translation', 'ui'],
      returnNull: false,
      supportedLngs: BaseLanguageList.map((item) => item.key),
      ...options,
    });
};

export { i18n as i18nInstance, initI18n };
